// extracted by mini-css-extract-plugin
export var container = "_4p-0";
export var fallback = "_4p-5";
export var fallbackIcon = "_4p-6";
export var hidden = "_4p-2";
export var image = "_4p-3";
export var loaded = "_4p-4";
export var placeholder = "_4p-1";